/**
 * JSON-LD de l'accueil anglais (/en). Équivalent du bloc statique
 * d'index.html (FR), que l'accueil FR conserve tel quel. Données
 * structurées pour robots, pas du texte d'interface.
 */
const faq: [string, string][] = [
  [
    "What is DooDates?",
    "DooDates is an event scheduling tool based on date polls. It lets you create polls, invite participants and find the right date for your event.",
  ],
  [
    "How do I create a poll?",
    "Click 'Create a poll', add the dates you want to propose, enter your event title, then share the link with your participants.",
  ],
  [
    "Can I export the results?",
    "Yes: CSV for free; PDF, JSON and Markdown with Solo.",
  ],
  [
    "Is my data secure?",
    "Yes, your data is hosted securely and never shared with third parties. See our privacy policy for details.",
  ],
  [
    "Is DooDates free?",
    "Yes, DooDates is completely free to create and share date polls. A free account gives you the dashboard, CSV export and one-click reminders; automatic reminders are included in Solo.",
  ],
  [
    "Do participants need an account to vote?",
    "No, participants can vote without creating an account. They just open the poll link and pick their availability.",
  ],
  [
    "Does DooDates show ads?",
    "No, DooDates is completely ad-free, for organizers and participants alike.",
  ],
  [
    "How is DooDates different from other date poll tools?",
    "DooDates stands out with its modern interface, AI-assisted poll creation, no ads at all, and voting without an account. It is designed to be simple and fast for both the organizer and the participants.",
  ],
  [
    "How many participants can I invite?",
    "No limit, with or without an account.",
  ],
  [
    "Do polls expire?",
    "Polls stay open until you close them or set an expiry date. With an account, you can manage and archive your past polls.",
  ],
  [
    "Can I create a poll without signing up?",
    "Yes, you can create and share a poll without an account. A free account lets you find your polls in the dashboard, export to CSV and remind your guests in one click; automatic reminders are included in Solo.",
  ],
  [
    "Does DooDates work on mobile?",
    "Yes, DooDates is fully responsive. Participants can vote from their phone without installing an app.",
  ],
  [
    "How do I share a poll?",
    "Once your poll is created, copy the link and share it via WhatsApp, SMS, email or social media. Participants need no account to vote.",
  ],
];

const steps: [string, string][] = [
  ["Create a poll", "Click 'Create a poll' and give your event a title."],
  ["Add dates", "Select the dates you want to propose to your participants."],
  ["Share the link", "Copy your poll link and send it to your participants."],
  [
    "Pick the date",
    "Check the results and choose the date that suits the most people.",
  ],
];

export const HOME_JSON_LD_EN: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SoftwareApplication",
      name: "DooDates",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      inLanguage: "en",
      url: "https://doodates.com/en",
      description:
        "DooDates is an event scheduling tool based on date polls. Create, share and vote to find the right date.",
      offers: [
        { "@type": "Offer", name: "Free", price: "0", priceCurrency: "EUR" },
        {
          "@type": "Offer",
          name: "Solo",
          price: "30",
          priceCurrency: "EUR",
          priceSpecification: {
            "@type": "UnitPriceSpecification",
            price: "30",
            priceCurrency: "EUR",
            billingDuration: "P1Y",
          },
        },
      ],
    },
    {
      "@type": "FAQPage",
      inLanguage: "en",
      mainEntity: faq.map(([name, text]) => ({
        "@type": "Question",
        name,
        acceptedAnswer: { "@type": "Answer", text },
      })),
    },
    {
      "@type": "HowTo",
      inLanguage: "en",
      name: "How to schedule an event with DooDates",
      step: steps.map(([name, text], i) => ({
        "@type": "HowToStep",
        position: i + 1,
        name,
        text,
      })),
    },
  ],
};
